import { waLink } from "./data";

export const LOCAL_PAGES = [
  {
    slug: "pasang-cctv-rangkasbitung",
    category: "cctv",
    h1: "Jasa Pasang CCTV Rangkasbitung",
    metaTitle: "Jasa Pasang CCTV Rangkasbitung — SATCOM Media Teknologi",
    metaDesc: "Jasa jual & pasang CCTV di Rangkasbitung. Paket CCTV Dahua 2MP/5MP, garansi resmi, termasuk pemasangan. Konsultasi gratis via WhatsApp.",
    intro: "Butuh pasang CCTV di Rangkasbitung? SATCOM Media Teknologi melayani penjualan dan pemasangan CCTV untuk rumah, toko, kantor, dan gudang dengan paket lengkap serta garansi resmi.",
    wa: "Halo SATCOM, saya mau konsultasi pasang CCTV di Rangkasbitung.",
    points: [
      { t: "Paket lengkap + pasang", d: "Sudah termasuk kamera, DVR, hardisk, kabel, dan pemasangan." },
      { t: "Kualitas 2MP & 5MP", d: "Pilihan resolusi jernih dengan mode Full Color & audio." },
      { t: "Garansi resmi 1 tahun", d: "Perangkat bergaransi dan layanan purna jual yang jelas." },
      { t: "Survey & konsultasi", d: "Rekomendasi titik kamera sesuai kondisi lokasi Anda." },
    ],
  },
  {
    slug: "cctv-lebak",
    category: "cctv",
    h1: "Pasang CCTV Lebak",
    metaTitle: "Pasang CCTV Lebak — Jual & Pasang CCTV | SATCOM",
    metaDesc: "Layanan jual & pasang CCTV di Kabupaten Lebak. Paket CCTV bergaransi untuk rumah & bisnis. Hubungi SATCOM via WhatsApp.",
    intro: "SATCOM Media Teknologi melayani pemasangan CCTV di seluruh wilayah Kabupaten Lebak. Amankan rumah dan usaha Anda dengan sistem CCTV yang andal.",
    wa: "Halo SATCOM, saya mau konsultasi pasang CCTV di Lebak.",
    points: [
      { t: "Melayani area Lebak", d: "Rangkasbitung dan sekitarnya dalam jangkauan layanan." },
      { t: "Untuk rumah & bisnis", d: "Solusi keamanan untuk toko, kantor, gudang, hingga rumah." },
      { t: "Harga transparan", d: "Paket jelas, konsultasi dulu sebelum pemasangan." },
    ],
  },
  {
    slug: "cctv-banten",
    category: "cctv",
    h1: "CCTV Banten — Jual & Pasang",
    metaTitle: "CCTV Banten — Jual & Pasang CCTV Bergaransi | SATCOM",
    metaDesc: "Penyedia & teknisi CCTV area Banten (Lebak, Rangkasbitung). Paket CCTV Dahua bergaransi + pemasangan profesional. Konsultasi via WhatsApp.",
    intro: "Cari CCTV di Banten? SATCOM Media Teknologi menyediakan perangkat dan jasa pemasangan CCTV dengan kualitas dan garansi resmi.",
    wa: "Halo SATCOM, saya mau konsultasi CCTV area Banten.",
    points: [
      { t: "Perangkat berkualitas", d: "CCTV Dahua dengan pilihan 2MP hingga 5MP." },
      { t: "Pemasangan profesional", d: "Instalasi rapi dan konfigurasi remote view di HP." },
      { t: "Dukungan lokal", d: "Berbasis di Rangkasbitung, mudah dihubungi." },
    ],
  },
  {
    slug: "pasang-parabola-rangkasbitung",
    category: "parabola",
    h1: "Pasang Parabola Rangkasbitung",
    metaTitle: "Pasang Parabola Rangkasbitung — K-Vision, Nex, Transvision | SATCOM",
    metaDesc: "Jasa jual & pasang parabola di Rangkasbitung. Gratis paket premium 1 tahun, garansi STB & LNB. Hubungi SATCOM via WhatsApp.",
    intro: "SATCOM melayani penjualan dan pemasangan parabola di Rangkasbitung dengan ratusan channel premium dan gambar Full HD.",
    wa: "Halo SATCOM, saya mau konsultasi pasang parabola di Rangkasbitung.",
    points: [
      { t: "K-Vision, Nex, Transvision", d: "Ratusan channel premium: film, olahraga, & berita." },
      { t: "Gratis paket 1 tahun", d: "Nikmati channel premium tanpa biaya bulanan tambahan." },
      { t: "Gratis pemasangan", d: "Pemasangan standar & garansi STB dan LNB 1 tahun." },
    ],
  },
  {
    slug: "wifi-rangkasbitung",
    category: "wifi",
    h1: "Pasang WiFi & Internet Rangkasbitung",
    metaTitle: "WiFi Rangkasbitung — Internet Full Fiber Unlimited | SATCOM",
    metaDesc: "Pasang WiFi internet Full Fiber di Rangkasbitung. Tanpa FUP, unlimited perangkat, harga mulai Rp 149.990/bulan. Hubungi SATCOM.",
    intro: "Internet WiFi Full Fiber untuk rumah dan usaha di Rangkasbitung. Stabil, tanpa batas kuota, dan unlimited perangkat.",
    wa: "Halo SATCOM, saya mau pasang WiFi internet di Rangkasbitung.",
    points: [
      { t: "Full Fiber, bukan paralel", d: "Koneksi stabil untuk kerja, streaming, & gaming." },
      { t: "Tanpa FUP", d: "Tanpa batas kuota dan unlimited perangkat." },
      { t: "Mulai Rp 149.990/bln", d: "Beberapa paket dengan bonus channel TV premium." },
    ],
  },
  {
    slug: "jaringan-komputer-rangkasbitung",
    category: "network",
    h1: "Jasa Jaringan Komputer Rangkasbitung",
    metaTitle: "Jasa Jaringan Komputer Rangkasbitung — MikroTik & Server | SATCOM",
    metaDesc: "Jasa instalasi jaringan & server (MikroTik, Windows, Linux) di Rangkasbitung. Untuk kantor, warnet, & bisnis. Konsultasi via WhatsApp.",
    intro: "SATCOM menyediakan jasa instalasi dan konfigurasi jaringan komputer serta server untuk kantor, warnet, dan bisnis di Rangkasbitung.",
    wa: "Halo SATCOM, saya mau konsultasi jaringan komputer di Rangkasbitung.",
    points: [
      { t: "Setup MikroTik", d: "Routing, bandwidth management, hotspot & user manager." },
      { t: "Server Windows & Linux", d: "AD domain, web server, database, mail server, & backup." },
      { t: "Untuk bisnis & kantor", d: "Jaringan stabil dan aman sesuai kebutuhan." },
    ],
  },
  {
    slug: "hardware-komputer-lebak",
    category: "komputer",
    h1: "Hardware Komputer Lebak",
    metaTitle: "Hardware Komputer Lebak — Rakitan PC & Laptop | SATCOM",
    metaDesc: "Penyedia hardware komputer, rakitan PC custom, & laptop di Lebak/Rangkasbitung. Merek ASUS, Acer, Dell, HP. Konsultasi via WhatsApp.",
    intro: "SATCOM menyediakan hardware komputer, rakitan PC custom, dan laptop berbagai merek untuk kebutuhan di Lebak dan Rangkasbitung.",
    wa: "Halo SATCOM, saya mau tanya hardware komputer / rakitan PC di Lebak.",
    points: [
      { t: "Rakitan PC custom", d: "Budget Anda, spek Anda — dari entry hingga gaming/editing." },
      { t: "Penyedia laptop", d: "ASUS, Acer, Dell, HP, dan lainnya." },
      { t: "Gratis software utama", d: "OS, driver, dan game populer + garansi lengkap." },
    ],
  },
  {
    slug: "teknisi-cctv-lebak",
    category: "cctv",
    h1: "Teknisi CCTV Lebak",
    metaTitle: "Teknisi CCTV Lebak — Pasang & Perbaikan CCTV | SATCOM",
    metaDesc: "Teknisi CCTV berpengalaman di Lebak & Rangkasbitung. Pemasangan, perbaikan, & setting remote view. Hubungi SATCOM via WhatsApp.",
    intro: "Butuh teknisi CCTV di Lebak? SATCOM siap membantu pemasangan baru, perbaikan, hingga setting remote view CCTV Anda.",
    wa: "Halo SATCOM, saya butuh teknisi CCTV di Lebak.",
    points: [
      { t: "Pemasangan & perbaikan", d: "Instalasi baru maupun perbaikan sistem CCTV lama." },
      { t: "Setting remote view", d: "Pantau CCTV dari HP kapan saja, di mana saja." },
      { t: "Respon cepat", d: "Berbasis di Rangkasbitung, mudah dihubungi via WhatsApp." },
    ],
  },
];

export const getLocalPage = (slug) => LOCAL_PAGES.find((p) => p.slug === slug);
export const localWa = waLink;
